import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AlertService } from '../Alert/alert.service';
import { BaseService } from '../base.service';

@Injectable({
  providedIn: 'root',
})
export class FavouriteService extends BaseService {
  constructor(
    private http: HttpClient,
    alertService: AlertService
  ) {
    super('favourite', alertService);
  }

  getFavouriteWorkstations(id: number): Observable<any> {
    const url = this.url + '/user/' + id;

    return this.http.get(url).pipe(
      map((data) => data),
      catchError((err) => this.handleError('Error Getting User Favourite Workstations', err))
    );
  }

  addFavouriteWorkstation(userFavourite: any, handleError = true): Observable<any> {
    const url = this.url + '/';

    if (handleError)
      return this.http.post(url, userFavourite).pipe(
        map((data) => data),
        catchError((err) => this.handleError('Error Adding User Favourite Workstation', err))
      );
    else return this.http.post(url, userFavourite).pipe();
  }

  removeFavouriteWorkstation(
    userId: number,
    workstationId: number,
    handleError = true
  ): Observable<any> {
    const url = this.url + '/';

    var params = new HttpParams();
    params = params.set('userId', userId.toString());
    params = params.set('workstationId', workstationId.toString());

    if (handleError)
      return this.http.delete(url, { params: params }).pipe(
        map((data) => data),
        catchError((err) => this.handleError('Error Removing User Favourite Workstation', err))
      );
    else return this.http.delete(url, { params: params }).pipe();
  }
}
